/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Cognos Analytics Home
 *| (C) Copyright IBM Corp. 2020, 2022
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define({
	homePageTitleLabel: 'Домой',
	homePageTabsLabel: 'Содержимое домашней страницы',
	myContent: 'Мое содержимое',
	teamContent: 'Содержимое команды',
	folder: 'Папка',
	files: 'Файлы',
	actionMenu: 'Меню действий',
	myFolder: 'Мои папки',

	emptyFolderNoContent: 'Нет содержимого',

	//EmptyStates
	emptyRecentTitle: 'Вы недавно не просматривали никакого содержимого.',
	emptyStateTitle: 'Начать с добавления данных',
	emptyStateBody: 'Щелкните по Закачать данные выше или перетащите его, чтобы закачать данные.',
	emptySearchResultTitle: 'Хм, ваш поиск не дал никаких результатов.',
	emptyPortalTitle: 'Нет порталов',
	emptyPortalBody: 'В настоящее время у вас нет порталов.',
	emptyWsProjectTitle: 'Начните с создания блокнота в Watson Studio.',
	emptyWsProjectBody: 'Когда вы вернетесь в Cognos Analytics, ваш блокнот будет показан здесь.',
	emptyFilteredResultTitle: 'Примененные фильтры не дали никаких результатов.',
	emptyDialogViewTitle: 'Нет элементов.',
	removeFromRecents: 'Удалить из последних',

	// Welcome Banner
	welcomeBannerGreeting: 'Здравствуйте! Вас приветствует Cognos Analytics with Watson.',
	welcomeBannerDescription: 'Cognos Analytics with Watson предоставляет пользователям возможность самостоятельно выполнять аналитические задачи с помощью функций ИИ. Узнайте, как автоматизированная подготовка данных, обнаружение данных и визуализации помогают принимать решения более уверенно.',
	welcomeBannerDescription_trialUser: 'Вы можете сразу же приступить работе, посмотрев наш вводный видеоролик, сделав экскурсию по продукту и открыв вкладку Начинаем работу.',
	takeTourButtonLabel: 'Совершите экскурсию по продукту',
	watchVideoButtonLabel: 'Посмотреть видео',
	// confirmation dialog
	hideWelcomeBannerMsg: 'Вы уверены, что хотите отключить баннер с приветствием на домашней странице? Можно снова включить это в любое время: Профиль и параметры > Параметры > Общие. ',
	hideWelcomeBannerTitle: 'Отключить баннер приветствия',
	ok: 'ОК',
	cancel: 'Отмена',
	warn: 'Предупреждение',
	//howto video dialog
	modal_how_title: 'Смотрите обзор Cognos Analytics',
	modal_overview_title: 'Смотрите обзор Cognos Analytics',
	modal_how_play: 'Воспроизвести видео',
	modal_how_video_title_overview: 'Обзор',
	modal_how_video_title_getStarted: 'Начинаем работу в 11.2',
	modal_how_video_title_newUI: 'Добро пожаловать в новый опыт работы в Cognos',
	modal_how_video_title_dataModule: 'Обзор модулей данных',
	modal_how_video_title_explore: 'Обзор исследования данных',
	modal_how_video_title_dashboard: 'Обзор интерактивных сводных панелей мониторинга',
	modal_how_video_title_reporting: 'Обзор составления отчетов',
	modal_how_video_title_mobile: 'Сила Cognos на вашей ладони',

	// Toolbar
	search: 'Поиск',
	addFolder: 'Добавить папку',
	addLink: 'Добавить ссылку',
	filter: 'Фильтр',
	sort: 'Сортировать',
	settings: 'Параметры',
	tilesView: 'Представление плитки',
	listView: 'Представление списка',
	columnView: 'Представление столбца',
	backToSearch: 'Вернуться к результатам поиска',

	// Toolbar Actions
	sortBy: 'Сортировать по',
	sortOrder: 'Порядок',
	name: 'Имя',
	modifiedTime: 'Изменено',
	type: 'тип',
	ascending: 'По восходящей',
	descending: 'По нисходящей',
	resetSort: 'Сброс сортировки',

	filterType: 'тип',
	filterModificationTime: 'Изменено',
	all: 'Все',
	today: 'Сегодня',
	yesterday: 'Вчера',
	pastWeek: 'Прошлая неделя',
	pastMonth: 'Прошлый месяц',
	resetFilters: 'Сбросить фильтры',
	resultLimit: 'Предел результата',

	filterSearchPlaceHolder: 'Фильтр по ключевым словам',

	resetFilterTag: 'Щелкните по X, чтобы сбросить фильтры.',
	filterTagToolTip: 'Примененные фильтры: %{appliedFilters}.',

	folderName: 'Имя папки',
	addAFolder: 'Добавить папку',
	add: 'Добавить',
	error: 'Ошибка',
	newFolderDefaultName: 'Новая папка',
	toastCreateNewFolder: 'Папка %{nameOfFolder} создана в %{tabName}.',
	folderAdded: 'Папка добавлена',
	refresh: 'Обновить',
	openFolder: 'Открыть папку',

	addAUrl: 'Добавить URL',
	linkName: 'Имя URL',
	linkNamePlaceholder: 'Добавить имя URL',
	linkDescription: 'Описание (необязательно)',
	linkDescriptionPlaceholder: 'Добавить описание',
	linkUri: 'URL',
	linkUriPlaceholder: 'Добавить URL с допустимым доменом',
	acceptableDomains: 'Допустимые домены',
	viewAcceptableDomains: 'Просмотреть допустимые домены',
	mandatoryField: 'Обязательное поле',
	linkAdded: 'URL добавлен',
	toastCreateNewLink: '%{nameOfLink} добавлен к %{tabName}.',
	noEntries: 'В списке допустимых доменов нет никаких записей. Обратитесь к администратору.',
	unacceptableDomain: 'В вашем URL используется недопустимый домен. Щелкните по \'Просмотреть допустимые домены\', чтобы увидеть список доменов, которые можно использовать.',

	compact: 'Компактная',
	short: 'Короткий',
	default: 'По умолчанию',
	rowSize: 'Размер строки',

	// GroupyByTypes
	folders: 'Папки',
	reports: 'Отчеты',
	dashboards: 'Cводные панели',
	data: 'Данные',
	packages: 'Пакеты',
	explorations: 'Исследования',
	stories: 'Истории',
	notebooks: 'Блокноты',
	others: 'Другое',

	// Error Messages
	itemsOverLimit: 'В указанном имени "%{itemName}" превышен максимальный предел (20). Чтобы продолжить, укажите другое имя.',
	errorMessageLengthFolderName: 'Введите имя папки, содержащее не более 255 символов.',
	errorMessageLengthLinkName: 'Введите имя ссылки, содержащее не более 255 символов.',
	toastLaunchPerspectiveError: 'Не удается открыть %{objectType}.',
	errorNoAccessTitle: 'Хм, похоже, у вас нет доступа к этому контенту',
	errorNoAccessBody: 'Свяжитесь со своим администратором или перейдите по следующей ссылке:',
	errorEnableExternalContent: 'Как включить внешнее содержимое',

	//TableHeader
	lastAccessed: 'Последний доступ',
	location: 'Расположение',
	tenant: 'Арендатор',

	// GetStartedTab
	getStartedLabel: 'Начните эффективно работать в IBM Cognos Analytics',
	learningHowToLabel: 'Ресурсы для обучения',
	learningHowToDescription: 'Расширьте свои знания и получите помощь по соединению с сообществом, читая документацию и просматривая видео.',
	learningHowToActionLabel: 'Запустить панель обучения',
	howToVideosLabel: 'Обучающие видео',
	howToVideosDescription: 'Узнайте, как использовать IBM Cognos Analytics и начать получать информацию из ваших данных.',
	howToVideosActionLabel: 'Посмотреть видео',
	acceleratorCatalogLabel: 'Каталог ускорителей',
	acceleratorCatalogDescription: 'Просмотрите растущий каталог промышленного использования, лучшие практические руководства, пользовательские визуализации и многое другое.',
	acceleratorCatalogActionLabel: 'Выбрать в каталоге',
	sampleSectionTitle: 'Примеры',
	sampleSectionDescription: 'Поэкспериментируйте с примерами, которые показывают все, что предлагает Cognos Analytics.',
	// Samples Section
	createDashboardSampleTitle: 'Как создать вашу первую сводную панель',
	createDashboardSampleDescription: 'Начни свое аналитическое путешествие с Cognos Dashboards.',
	nlaSampleTitle: 'Пример отчета',
	nlaSampleDescription: 'Изучите возможности Cognos Analytics Reports на этом примере анализа активности участников программы лояльности в конце года.',
	sankeySampleTitle: 'Sankey',
	sankeySampleDescription: 'Раскройте библиотеку визуализации с пользовательскими визуализациями, такими как диаграмма Sankey.',
	viewAllSamplesActionLabel: 'Просмотреть все образцы',
	byFeatureTitle: 'По функциям',
	byFeatureDescription: 'Просматривайте образцы по функциям, таким как основные функции, настраиваемые элементы управления, расширения, блокноты и относительные даты.',
	byIndustryTitle: 'По отраслям',
	byIndustryDescription: 'Просмотрите примеры по отраслям, таким как автомобилестроение, банковское дело и др.',
	// SamplesTab
	sampleTabTitle: 'Вдохновляйтесь нашими готовыми образцами',
	sampleTabLabel: 'Посетите Accelerator Catalog, чтобы получить больше примеров и расширений от IBM, партнеров и заказчиков.',

	// quickLaunch
	quickLaunchLabel: 'Быстрый запуск',
	expand: 'Развернуть',
	collapse: 'Свернуть',

	// quickLaunch dialog
	quickLaunchModalLabel: 'Начните с выбора того, что вы хотите создать.',

	// contentPageView
	contentPageTitleLabel: 'Содержимое',
	uploadFile: 'Закачать данные',
	new: 'Создать',
	create: 'Создать',
	more: 'Дополнительно',

	// open dialog
	selectDataSourcesToAdd: 'Выберите один или несколько источников данных для добавления.',
	openDialogDefaultTitle: 'Открыть',

	// save dialog
	save: 'Сохранить',
	saveAs: 'Сохранить как',
	saving: 'Выполняется сохранение...',
	selectedDestination: 'Выбранное место назначения: %{nameOfFolder}',
	toastDuplicateFileDifferentType: '\'%{nameOfItem}\' уже существует с другим типом. Надо выбрать другое имя.',
	confirmOverwriteTitle: 'Подтвердить замену существующих данных',
	confirmOverwriteMsg: 'Файл \'%{nameOfFile}\' уже существует. Хотите заменить его данные данными, содержащимися в выбранном файле?',

	// copy move dialog
	copy: 'Копировать',
	move: 'Переместить',
	copyOrMove: 'Копировать или переместить: ',
	copyOnly: 'Копировать ',
	createShortcut: 'Создать ярлык',
	createShortcutDialogTitle: 'Создать ярлык ',

	// External asset types
	wsProject: 'Проект Watson Studio',
	externalContentTypeWs: 'Watson Studio',

	// Asset Types
	package: 'Пакет',
	dataModule: 'Модуль данных',
	exploration: 'Исследование',
	mode: 'Режим',
	live: 'Активный',
	snapshot: 'Снимок',
	noSnapshotsFound: 'Никаких снимков не найдено',
	uploadedFile: 'Закачанный файл',
	fileUpload: 'Закачать данные',
	dataSetEx: 'Набор данных',
	externalRepository: 'Внешний репозиторий',
	queryMode: 'Режим запросов',
	queryModeCompatible: 'Совместимый',
	queryModeDynamic: 'Динамический',
	report: 'Отчет',
	activeReport: 'Активный отчет',
	query: 'Запрос',
	analysis: 'Анализ',
	dashboard: 'Сводная панель',
	dashboardTemplate: 'Шаблон сводной панели',
	jupyterNotebook: 'Блокнот',
	wsNotebook: 'Среда Notebook Watson Studio',
	jupyter: 'Jupyter',
	ws: 'Watson Studio',
	story: 'История',
	workspace: 'Рабочее пространство',
	pagelet: 'Страница',
	content: 'Содержимое',
	directory: 'Пространства имен',
	dataSet: 'Набор данных',
	powerPlayCube: 'Куб PowerPlay',
	powerPlayReport: 'Отчеты PowerPlay',
	powerPlay8Report: 'Отчеты PowerPlay',
	setPowerPlay8ReportOptions: 'Задать опции отчета PowerPlay',
	powerPlay8ReportView: 'Представление отчета PowerPlay',
	reportTemplate: 'Шаблон отчета',
	packageConfigurations: 'Конфигурация пакета',
	agent: 'Агент',
	agentDefinition: 'Определение агента',
	agentDefinitionView: 'Представление агента',
	dataMovementTask: 'Задача перемещения данных',
	dataMovementTaskAlias: 'Алиас задачи перемещения данных',
	document: 'Документ',
	DocumentRetention: 'Свойства документа',
	jobDefinition: 'Определение задания',
	job: 'Задание',
	jobs: 'Задания',
	metricsDataSourceETLTask: 'Задача ETL источника данных метрик',
	metricsExportTask: 'Задача экспорта метрик',
	metricsFileImportTask: 'Задача импорта файла метрик',
	metricsMaintenanceTask: 'Задача управления метриками',
	planningTask: 'Задача планирования',
	shortcut: 'Ярлык',
	shortcuts: 'Ярлыки',
	URL: 'URL',
	launchable: 'Можно запустить',
	dataSetFolder: 'Папка набора данных',
	ViewAccessibleLabel: 'Просмотр %{label}',
	overrideReportOptions: 'Переопределить опции отчета по умолчанию',
	formats: 'Форматы',
	saveReport: 'Сохранить отчет',
	reportView: 'Представление отчета',
	reportviews: 'Представления отчетов',
	html: 'HTML',
	pdf: 'PDF',
	spreadsheetML: 'Excel',
	xlsxData: 'Данные Excel',
	csv: 'CSV',
	xml: 'XML',
	txt: 'TXT',
	role: 'Роль',
	namespace: 'Пространство имен',
	namespaceFolder: 'Папка пространства имен',
	adminFolder: 'Папка администрирования',
	//Details
	details: 'Сведения',
	open: 'Открыть',
	created: 'Создано',
	modified: 'Изменено',
	owner: 'Владелец',
	dataSource: 'Источник данных',
	share: 'Совместно',
	addToFavorites: 'Добавить в избранное',
	properties: 'Свойства',
	detailsEmptyStateBody: 'Выберите элемент для просмотра его подробностей',
	editNameAndDescription: 'Изменить имя и описание',
	none: 'Нет',
	setPdfOptions: 'Задать опции PDF',
	runOptions: 'Опции запуска',

	//rename dialog
	nameInvalid: 'Недопустимое имя',
	namePlaceholder: 'Ввести имя',
	description: 'Описание',
	descriptionInvalid: 'Описание не может содержать больше 350 символов.',
	descriptionPlaceholder: 'Введите описание',
	errorMessageApostropheError: 'Введите имя файла, не содержащее символов \' и "',
	renameCollisionError: '%{name} уже существует. Попробуйте другое имя.',
	unknownRenameError: 'Не удалось переименовать элемент. Обратитесь к администратору за дополнительной помощью.',

	//types
	xls: 'xls',
	xlsx: 'xlsx',

	unableToOpenFolderMsg: 'Не удается открыть указанную папку.',

	//Upload
	uploadToFolder: "Закачать в <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>%{launchAction}",
	uploadAndLaunch: "Закачать в <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span> и запустить%{launchAction}",
	quickUpload: "Быстрая закачка",
	quickUploadAndLaunch: "Перетащите файлы для закачки в <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span> и откройте в одном из следующих пространств.",
	unsupportedFilesSingle: "%{files} не закачали, так как он недопустим для быстрого запуска.",
	unsupportedFilesMultiple: "Файлы не закачали, потому что все файлы, которые вы выбираете, должны быть допустимы для Быстрого запуска.",
	unsupportedFilesSingleInvalid: "%{files} недопустим.",
	unsupportedFilesMultipleInvalid: "%{files} недопустимы.",
	supportedFileTypes: "Допустимы только следующие типы файлов: %{extensions}.",
	uploadDragAndDrop: "Перетаскивание",
	uploadDragAndDropMessage: "Перетащите сюда файл, чтобы закачать его в <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>",

	// searchBar
	searchWasSaved: 'Критерии поиска \'%{searchTerm}\' сохранены.',
	searchWasntSaved: 'Критерии поиска \'%{searchTerm}\' не сохранены.',
	searchSuggestions: 'Варианты',
	savedSearch: 'Сохраненные поиски',
	searchWasDeleted: 'Критерии поиска \'%{searchTerm}\' удалены.',
	searchWasntDeleted: 'Критерии поиска \'%{searchTerm}\' не удалены.',
	savedBarTitle: 'Поиск в Cognos Analytics',
	searchContentPageTitle: 'Поиск',
	searchContentPageTitleLabel: 'Показаны результаты для \'%{searchTerm}\'',
	showingSearchRsult: 'Вывод элементов %{resultCount}',
	saveSearch: 'Сохранить поиск',
	saveTenSearches: 'Можно сохранить 10 поисков.',
	deleteASearch: 'Удалите один, чтобы сохранить другой.',
	close: 'Закрыть',
	allContent: 'Все содержимое',
	searchResultIn: 'Результаты поиска: ',
	//recent view
	recents: 'Последние',
	noAccessRecent: 'Нет доступа',
	noAccessRecentMsg: 'У вас нет доступа к этому активу. Возможно, он отключен или удален, либо у вас сокращены права доступа. Проверьте состояния актива в его ожидаемом расположении источника. Вы можете удалить актив из ваших недавних элементов, нажав OK.',
	noAccessMsg: 'У вас нет доступа к этому активу. Возможно, он отключен или удален, либо у вас сокращены права доступа.',

	//contextToolbar
	itemsSelected: 'Выбрано %{nameOfSelection} элементов',
	itemSelected: 'Выбран %{nameOfSelection} элемент',

	//properties
	general: 'Общие',
	schedule: 'Расписание',
	permission: 'Разрешения',
	capabilities: 'Возможности',
	propertiesTabsLabel: 'Содержимое свойств',
	searchPath: 'Путь поиска',
	id: 'ID',
	language: 'Язык',
	setLanguage: 'Задать язык',
	entryOptions: 'Опции записи',
	setPackage: 'Задать пакет или модуль',
	sourcePackage: 'Исходный пакет или модуль данных',
	associatedSourceAgent: 'Исходный пакет',
	setAssociatedSourceAgent: 'Установить пакет',
	sourceAgent: 'Агент источника',
	setSourceAgent: 'Задать исходный агент',
	setCapabilities: 'Задать возможности',
	disableEntry: 'Выключить эту запись',
	hideEntry: 'Скрыть эту запись',
	permissions: 'Права доступа',
	promptForValues: 'Запрашивать значения',
	yes: 'Да',
	no: 'Нет',
	setValues: 'Задать значения',
	moreOptions: 'Дополнительные параметры',
	reportFormat: 'Формат отчетов',
	enableAccessibilitySupport: 'Включить поддержку специальных возможностей',
	displayOfRunHistory: 'Отображение хронологии выполнения',
	occurrences: 'Вхождения',
	days: 'Дни',
	months: 'Месяцы',
	displayOfReportOutputVersions: 'Показать версию вывода отчета',
	defaultDisplayOfPortalAction: 'Действие портала по умолчанию',
	viewMostRecentReport: 'Показать последний отчет',
	runTheReport: 'Запустить отчет',
	openWithReportStudio: 'Открыть в Report Studio',
	rowsPerPageInHtmlReports: 'Число строк на странице в отчетах HTML',
	enableSelectionBasedInteractivity: 'Включить интерактивность с учетом выбора',
	enableAlertsAboutNewVersions: 'Включить предупреждения о новых версиях',
	enableEnhancedUserFeaturesInSavedOutputVersions: 'Включить расширенные возможности пользователя в сохраненных версиях вывода',
	enableCommentsInSavedOutputVersions: 'Включить комментарии в сохраненных версиях вывода',
	run: 'Выполнить',
	runWithUsersCredentials: 'С идентификационными данными пользователя',
	runWithOwnerCapabilities: 'С правами доступа владельца',
	runAsOwner: 'Как %{ownerName}',
	actionLabelOn: 'Вкл',
	actionLabelOff: 'Выкл',
	openReport: 'Редактировать',
	openAnalysis: 'Открыть в Analysis Studio',
	openQuery: 'Открыть в Query Studio',
	openPowerPlay8Report: 'Открыть в PowerPlay Studio',
	openInteractiveReport: 'Редактировать',
	read: 'Чтение',
	write: 'Запись',
	execute: 'Выполн.',
	setPolicy: 'Назначение политики',
	full: 'Полный',
	traverse: 'Просмотр',
	grant: 'Предоставить',
	deny: 'Отказать',
	permissionCustom: 'Настроить',
	permissionDetailsColumnAccess: 'Доступ',
	permissionDetailsColumnPermission: 'Разрешение',
	permissionDetailsColumnAction: 'Действие',
	permissionSetAccess: 'Задать доступ',
	permissionRead: 'Чтение',
	permissionRun: 'Выполнить',
	permissionWrite: 'Запись',
	permissionFull: 'Полный',
	unavailable: 'Недоступно',
	unkownSource: 'Неизвестно, откройте отчет для подробностей',
	tenantSettings: 'Параметры арендатора',
	tenantSet: 'Арендатор изменен',
	tenantSetError: 'Ошибка при задании арендатора',
	tenantClear: 'Арендатор очищен',
	tenantClearError: 'Ошибка при очистке арендатора',
	shortcutTo: 'Ярлык',
	sourceReport: 'Исходный отчет',
	setSourceReport: 'Задать исходный отчет',
	setSourceLocation: 'Задать источник%{itemName}',
	linkPackageOrModule: 'Связывать%{itemName} с пакетом или модулем данных',
	linkPackage: 'Связать%{itemName} с пакетом',
	externalRepositories: 'внешние репозитории',
	sizeByte: '%{value} B',
	sizeKiloByte: '%{value} КБ',
	sizeMegaByte: '%{value} МБ',
	sizeGigaByte: '%{value} ГБ',
	sizeTeraByte: '%{value} ТБ',
	sizePetaByte: '%{value} ПБ',
	refreshedDatetime: 'Время обновления',
	size: 'Размер',
	tenantsWarningMessage: 'При изменении арендатора для записи также изменится арендатор для дочерних записей.',
	confirmClearTenantText: 'Очистка значения \'Нет\' может позволить другим арендаторам получить доступ к содержимому. Нажмите кнопку OK, чтобы сделать запись общедоступной, или кнопку Отмена, чтобы оставить текущего арендатора.',
	confirmClearTenant: 'Подтвердить очистку арендатора',
	currentValues: 'Текущие значения',
	emptyPromptValues: 'В настоящее время нет значений',
	editValues: 'Изменить значения',
	clear: 'Очистить',
	source: 'Источник',
	dataRefreshed: 'Данные обновлены',
	//PDF options
	pdfOptions: 'Опции PDF',
	set: 'Принять',
	portrait: 'Книжная',
	landscape: 'Альбомная',
	letter: 'Letter',
	legal: 'Legal',
	elevenxSeven: '11x17',
	A3: 'A3',
	A4: 'A4',
	b4jis: 'B4JIS',
	b5jis: 'B5JIS',
	orientation: 'Ориентация',
	pageDefination: 'Размер бумаги',
	openPasswordRequired: 'Требовать пароль для открытия отчета',
	accessPasswordRequired: 'Требовать пароль для доступа к отчету',
	emptyPassword: 'Пароль не должен быть пустым',
	password: 'Пароль',
	enterPassword: 'Введите пароль',
	confirmPassword: 'Подтверждение пароля',
	passwordMatchError: 'Пароли не совпадают',
	gateway: 'Шлюз',
	pageLayout: 'Структура страницы',
	pageStyle: 'Стиль',
	setUrl: 'Задать URL',
	numberRows: 'Число строк',
	numberColumns: 'Число столбцов',
	timeToRefresh: 'Время для обновления',
	lastRefreshedBy: 'Кем обновлено',
	unknown: 'Неизвестно',
	unknownUpdateError: 'Обновление элемента завершилось неудачно. Обратитесь к администратору за дополнительной помощью.',
	editQuery: 'Изменить запрос',
	greaterOrEqual: 'Больше или равно%{upperboundValue}',
	lessOrEqual: 'Меньше или равно%{lowerboundValue}'
});
